import { Button, Dialog, IconButton, TextField } from "@material-ui/core"
import CloseIcon from "@material-ui/icons/Close"
import { PropTypes } from "prop-types"

export default function DemoUsersDialog({
  open,
  handleClose,
  handleTransferInput,
  setTokenDialogOpen,
  firstName,
  lastName,
  setFirstName,
  setLastName,
}) {
  const openTokenDialog = () => {
    handleTransferInput()
    setTokenDialogOpen(true)
  }

  return (
    <Dialog open={open} maxWidth="xs">
      <div
        className="flex flex-col gap-y-2"
        style={{
          padding: "30px 40px",
          paddingTop: "30px",
        }}
      >
        <div className="flex justify-between items-center w-full">
          <p style={{ fontSize: 18, marginBottom: 0 }}>Create Demo User</p>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </div>

        <div className="flex flex-col gap-4">
          <input
            className="block w-full rounded-md border-0 px-2 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            value={firstName || ""}
            placeholder="First Name (optional)"
            onChange={(e) => setFirstName(e.target.value)}
          />
          <input
            className="block w-full rounded-md border-0 px-2 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            value={lastName || ""}
            placeholder="Last Name (optional)"
            onChange={(e) => setLastName(e.target.value)}
          />
          <Button variant="contained" color="primary" onClick={openTokenDialog}>
            Create Demo User
          </Button>
        </div>
      </div>
    </Dialog>
  )
}

DemoUsersDialog.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  handleTransferInput: PropTypes.func,
  setTokenDialogOpen: PropTypes.func,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  setFirstName: PropTypes.func,
  setLastName: PropTypes.func,
}
